<template>
  <loader ref="loader" />
  <navbar
    @loader="loader"
    ref="navbar"
    v-show="show_nav"
    @logged_out="logged_out"
  />
  <!-- <modul-version /> -->
  <router-view @update_nav="update_nav" @hide_nav="hide_nav" />
  <command-palette-modal ref="command_palette_modal" :shortkeys="shortkeys" />
  <terminal-modal ref="terminal_modal" @system_signal="system_signal" />
  <!-- <assistant-plugin ref="assistant_plugin" /> -->
</template>

<script>
import Navbar from "@/components/navbar/Index";
import Loader from "@/components/loader/Loader.vue";
// import ModulVersion from "@/components/ModulVersion.vue";
import CommandPaletteModal from "@/components/command_palette_modal/Index.vue";
import TerminalModal from "@/components/terminal_modal/Index.vue";
// import AssistantPlugin from "../../modules/assistant/frontend/plugin/Index.vue";
import { get_user_data, get, warning_message } from "@/utils";
import "../../assistant-sdk/src/index.js"; // Import the SDK

export default {
  name: "App",
  components: {
    Navbar,
    Loader,
    CommandPaletteModal,
    TerminalModal,
    // AssistantPlugin,
    // ModulVersion,
  },
  data: () => {
    return {
      shortkeys: [],
      show_nav: true,
    };
  },
  computed: {
    user_data() {
      return get_user_data();
    },
  },
  methods: {
    loader(value) {
      this.$refs.loader.set_loading(value);
    },
    update_nav() {
      this.$refs.navbar.update_nav();
      // this.$refs.assistant_plugin.refresh();
    },
    clear_shortkeys(/* path */) {
      let v = this;
      v.shortkeys.forEach((s) => {
        window.removeEventListener("keyup", s.listener);
      });
      v.shortkeys = [];
    },
    apply_shortkeys(profile) {
      let v = this;
      v.shortkeys = profile.settings.shortkeys.map((s) => {
        return {
          shortkey: s.shortkey,
          description: s.description,
          action: s.execute,
          listener: (event) => {
            let trgt_shortkey = profile.settings.shortkeys.find((s) => {
              let name = "";
              if (event.ctrlKey) name += "ctrl+";
              if (event.shiftKey) name += "shift+";
              if (event.altKey) name += "alt+";
              name += event.key;
              return s.shortkey == name;
            });
            if (trgt_shortkey) {
              try {
                eval(trgt_shortkey.execute);
              } catch (error) {
                console.error(error);
              }
            }
          },
        };
      });

      v.shortkeys.forEach((s) => {
        window.addEventListener("keyup", s.listener);
      });
    },
    show_command_palette() {
      let v = this;
      v.$refs.command_palette_modal.show_modal();
    },
    show_terminal() {
      let v = this;
      if (v.user_data) {
        if (v.user_data.is_developer) v.$refs.terminal_modal.show_modal();
        else
          warning_message(
            v.$t("terminal feature is available only for developers")
          );
      }
    },
    system_signal(signal) {
      let v = this;
      if (
        [
          "make_custom_build",
          "reset_system",
          "update_system",
          "generate_models",
          "build",
        ].includes(signal)
      )
        v.$refs.navbar.system_signal(signal);
    },
    hide_nav() {
      let v = this;
      v.show_nav = false;
    },
    logged_out() {
      // let v = this;
      // setTimeout(() => {
      // v.$refs.assistant_plugin.refresh();
      // }, 200);
    },
  },
  mounted() {
    let v = this;
    if (
      v.user_data &&
      v.user_data.settings &&
      v.user_data.settings.default_theme &&
      v.user_data.settings.default_theme != "dark"
    ) {
      import("bulma/css/versions/bulma-no-dark-mode.min.css")
        .then(() => {})
        .catch((error) => {
          console.error(error);
        });
      if (!["dark", "light"].includes(v.user_data.settings.default_theme))
        import(
          "bulmaswatch/" +
            v.user_data.settings.default_theme +
            "/bulmaswatch.min.css"
        )
          .then(() => {})
          .catch((error) => {
            console.error(error);
          });
    }
    // window.addEventListener("keyup", v.handle_keypress);

    window.show_terminal = () => {
      v.show_terminal();
    };
    window.show_command_palette = () => {
      v.show_command_palette();
    };

    let login_data = localStorage.getItem("login_data");
    if (login_data && window.ModulAssistantSDK) {
      let jldata = JSON.parse(login_data);
      if (jldata && jldata.assistant) {
        window.ModulAssistantSDK.init({
          apiKey: jldata.assistant,
          debug: false,
          title: "Asistente personal de Modul",
          theme: "professional",
        });
      }
    }
  },
  created() {
    let permissions = localStorage.getItem("permissions");
    if (!permissions) {
      get("/system/settings", {})
        .then((r) => {
          // localStorage.setItem("system_settings", JSON.stringify(r));
          if (r && r.free_use_urls)
            localStorage.setItem(
              "permissions",
              JSON.stringify(r.free_use_urls)
            );
        })
        .catch((err) => {
          console.error(err);
        });
    }
  },
  watch: {
    $route(to, from) {
      let v = this;
      v.clear_shortkeys(from.path);
      // console.log("route changed", to.path);
      let shortkeys = localStorage.getItem("shortkeys");
      // console.log("shortkeys", shortkeys);

      if (shortkeys) {
        let _shortkeys = JSON.parse(shortkeys);

        /**
         * Shortkey system
         */
        let system_shortkeys = _shortkeys.settings_shortkeys || {};
        if (
          system_shortkeys.shortkey_home ||
          system_shortkeys.shortkey_show_terminal ||
          system_shortkeys.shortkey_show_command_palette
        )
          window.addEventListener("keydown", (e) => {
            let name = "";
            if (e.ctrlKey) name += "ctrl+";
            if (e.shiftKey) name += "shift+";
            if (e.altKey) name += "alt+";
            name += e.key;
            // console.log(name, system_shortkeys);

            if (system_shortkeys.shortkey_home == name)
              this.$router.replace({ path: "/home" });
            else if (system_shortkeys.shortkey_show_terminal == name)
              window.show_terminal();
            else if (system_shortkeys.shortkey_show_command_palette == name) {
              window.show_command_palette();
            }
          });

        /**
         * Shortkey profiles
         */
        let shortkey_profiles = _shortkeys.profiles || [];
        let target_profile = shortkey_profiles.find((p) => {
          return p.path == to.path;
        });
        if (target_profile) {
          v.apply_shortkeys(target_profile);
        }
      }
    },
  },
};
</script>

<style>
/* body {
  background: #f1f1f1;
} */
.modal .modal-background {
  /* background-color: rgba(0, 0, 0, 0.7); */
  /* background-color: #ffffff44; */
  background-color: #000000c9;
}

.modal .modal-card {
  /* border: 4px solid #ff000044; */
  border-radius: 20px;
  box-shadow: 0px 0px 10px 2px rgba(0, 209, 178, 0.8);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
}
</style>
